import {ImageSourcePropType, ViewStyle} from 'react-native';
import {DocumentPickerAsset} from 'expo-document-picker';
import {ChatMessage} from './Contact';
// import images from '../../assets/images'
// import { ExtendedIMessage } from './Conversation'

export interface FileURLResponse extends FileUrlQueryParamsResponse {
  relativePath: string;
}

export interface FileUrlQueryParamsResponse {
  queryParams: {
    temp_url_sig: string;
    temp_url_expires: string;
  };
}
export interface FileStorageResponse {
  data: ArrayBuffer;
  filename: string;
}

export enum FileTypeApi {
  PNG = 'PNG',
  JPEG = 'JPEG',
  IMG = 'IMG',
  JPG = 'JPG',
  GIF = 'GIF',
  TXT = 'TXT',
  PDF = 'PDF',
  DOC = 'DOC',
  DOCX = 'DOCX',
  XLS = 'XLS',
  XLSX = 'XLSX',
  PPT = 'PPT',
  PPTX = 'PPTX',
  AAC = 'AAC',
  MP3 = 'MP3',
  AVI = 'AVI',
  M4A = 'M4A',
  MP4 = 'MP4',
  MOV = 'MOV',
  PCM = 'PCM',
  PROTO = 'PROTO',
  IPS = 'IPS',
}

// export const PreviewImagesToDocumentTypesMap: { [key in FileTypeApi]: ImageSourcePropType } = {
//   DOCX: images.fileDocx,
//   DOC: images.fileDocx,
//   XLSX: images.fileXlsx,
//   XLS: images.fileXlsx,
//   PPT: images.filePptx,
//   PPTX: images.filePptx,
//   PDF: images.filePdf,
//   PNG: images.fileBlank,
//   JPEG: images.fileBlank,
//   IMG: images.fileBlank,
//   JPG: images.fileBlank,
//   GIF: images.fileBlank,
//   TXT: images.fileBlank,
//   AAC: images.fileBlank,
//   MP3: images.fileBlank,
//   AVI: images.fileBlank,
//   M4A: images.fileBlank,
//   MP4: images.fileBlank,
//   MOV: images.fileBlank,
//   PCM: images.fileBlank,
//   PROTO: images.fileBlank,
//   IPS: images.fileBlank,
// }

export const ImageFormats = [
  FileTypeApi.IMG,
  FileTypeApi.JPEG,
  FileTypeApi.GIF,
  FileTypeApi.JPG,
  FileTypeApi.PNG,
];

export const MediaFormats = [
  FileTypeApi.AVI,
  FileTypeApi.M4A,
  FileTypeApi.MOV,
  FileTypeApi.MP3,
  FileTypeApi.AAC,
  FileTypeApi.PCM,
];

export const DocumentFormats = [
  FileTypeApi.DOC,
  FileTypeApi.DOCX,
  FileTypeApi.PDF,
  FileTypeApi.XLS,
  FileTypeApi.XLSX,
  FileTypeApi.PPT,
  FileTypeApi.PPTX,
];

export interface PickerAssetExtension {
  name: string;
  fileType: FileTypeApi;
  mimeType: keyof typeof fileTypesApi;
  size: number;
  fileSize: number;
}

export const fileTypesApi = {
  'image/png': FileTypeApi.PNG,
  'image/jpeg': FileTypeApi.JPEG,
  'image/jpg': FileTypeApi.JPG,
  'image/gif': FileTypeApi.GIF,
  'text/plain': FileTypeApi.TXT,
  // NOT SUPPORTED BY WEB
  'video/x-msvideo': FileTypeApi.AVI,
  'audio/mpeg': FileTypeApi.MP3,
  'audio/aac': FileTypeApi.AAC,
  'audio/mp4': FileTypeApi.M4A,
  'video/mp4': FileTypeApi.MP4,
  'video/quicktime': FileTypeApi.MOV,
  // NOT SUPPORTED BY WEB
  'application/pdf': FileTypeApi.PDF,
  'application/vnd.ms-excel': FileTypeApi.XLS,
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    FileTypeApi.XLSX,
  'application/msword': FileTypeApi.DOC,
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    FileTypeApi.DOCX,
  'application/vnd.ms-powerpoint': FileTypeApi.PPT,
  'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    FileTypeApi.PPTX,
};

export interface FileUploadRequestType {
  fileSize: string;
  fileType: FileTypeApi;
}

export interface FileDownloadRequestType {
  relativePath: string;
}

export type FilePreviewScreenParams =
  | FilePreviewScreenUploadParams
  | FilePreviewScreenViewParams;

export interface FilePreviewScreenViewParams {
  chatId: string;
  message: ChatMessage;
  dontRenderHeader?: true;
  style?: ViewStyle;
}

export type FilePreviewScreenUploadParams =
  | FilePreviewScreenUploadLocalParams
  | FilePreviewScreenUploadExternalParams;

export interface FilePreviewScreenUploadLocalParams {
  isEditable: true;
  chatId: string;
  asset: DocumentPickerAsset;
  fileType: FileTypeApi;
}

export interface FilePreviewScreenUploadExternalParams {
  chatId: string;
  isEditable: true;
  fileUrl: string;
  fileType: FileTypeApi;
}
